export default __webpack_public_path__ + "static/media/featured_on_best_dex.b06ff28a.svg";